import React from 'react';

const FormActions: React.FC = ({ children }) => <>{children}</>;

export default FormActions;
